import React, { FC, useEffect, useState } from 'react';
import { Box, Fade, Skeleton, Stack } from '@mui/material';
import { SelectField, SubTitle, TextArea } from 'components/generic';
import { ClientForm } from 'components/basket/BasketContent/Receiving';
import { DateTimePicker } from 'components/basket/BasketContent/Receiving/DeliveryTimeForm';
import { useFormContext } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'store/hooks/useAppSelector';
import { selectAvailablePickupRestaurantsList } from 'store/selectors/restaurantSelectors';
import { useTranslation } from 'react-i18next';
import { useReadyTime } from 'hooks/basket';
import { orderSlice } from 'store/reducers/OrderSlice/OrderSlice';
import { selectServerTimeIsLoading } from 'store/selectors/appSelectors';
import { selectCitiesIsLoading } from 'store/selectors/citySelectors';

const Pickup: FC = () => {
  const dispatch = useAppDispatch();
  const { addRestaurant } = orderSlice.actions;
  const { control, watch, setValue, reset } = useFormContext();
  const [isSelectTimeFrom, setIsSelectTimeForm] = useState<boolean>(false);
  const selectTimeData = useReadyTime();
  const receiving = watch('receiving');
  const restaurantId = watch('restaurant');
  const restaurantsList = useAppSelector(selectAvailablePickupRestaurantsList);
  const cityLoading = useAppSelector(selectCitiesIsLoading);
  const isServerTimeLoading = useAppSelector(selectServerTimeIsLoading);
  const { t } = useTranslation();
  const { clearPickupTime, addCallBack } = orderSlice.actions;

  useEffect(() => {
    dispatch(addCallBack());
    setValue('delivery_time', 1);
    reset();
  }, []);

  useEffect(() => {
    if (receiving === 2) {
      setIsSelectTimeForm(true);
    } else {
      setIsSelectTimeForm(false);
      dispatch(clearPickupTime());
    }
  }, [receiving]);

  useEffect(() => {
    setValue('restaurant', restaurantsList[0]?.value);
  }, []);

  useEffect(() => {
    if (restaurantId) {
      dispatch(addRestaurant(Number(restaurantId)));
    }
  }, [restaurantId]);

  return (
    <Fade in timeout={400}>
      <Box sx={{ maxWidth: '620px' }}>
        <Box sx={{ marginBottom: { xs: '13px', sm: '18px' } }}>
          <ClientForm />
        </Box>
        <Box sx={{ marginBottom: { xs: '13px', sm: '18px' } }}>
          <SubTitle>{t('pick_a_restaurant')}</SubTitle>
        </Box>
        <Box sx={{ marginBottom: { xs: '16px', sm: '30px' } }}>
          <SelectField
            control={control}
            name="restaurant"
            label={t('pick_a_restaurant')}
            required
            size="small"
            selectItem={restaurantsList}
            defaultValue=""
          />
        </Box>
        <Box sx={{ marginBottom: { xs: '13px', sm: '18px' } }}>
          <SubTitle>{t('order_by_time')}</SubTitle>
        </Box>
        <Box
          sx={{
            marginBottom: { xs: '16px', sm: '30px' },
            width: { xs: '100%', sm: '49%' },
          }}
        >
          <SelectField
            control={control}
            name="receiving"
            label={t('ready_time')}
            required
            size="small"
            selectItem={selectTimeData}
            defaultValue={1}
          />
        </Box>
        {isSelectTimeFrom && (
          <Stack
            sx={{ marginBottom: { xs: '16px', sm: '30px' } }}
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.6}
          >
            {cityLoading && isServerTimeLoading ? (
              <Skeleton variant="rectangular" height={50} />
            ) : (
              <DateTimePicker type="pickup" />
            )}
          </Stack>
        )}

        <Box>
          <TextArea
            control={control}
            name="comment"
            label={t('comment_on_the_order')}
          />
        </Box>
      </Box>
    </Fade>
  );
};

export default Pickup;
